import { render, staticRenderFns } from "./EventTypeRadioInput.vue?vue&type=template&id=63031fcd&"
import script from "./EventTypeRadioInput.vue?vue&type=script&lang=ts&"
export * from "./EventTypeRadioInput.vue?vue&type=script&lang=ts&"
import style0 from "./EventTypeRadioInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports